import React from 'react';
import {Text, View} from 'react-native';
import I18n from 'i18n-js';
import styles from '../../../style/adminTools';
import {ListEmpty, ListUnavailable} from './ListState';

const StoresList = ({stores}) => {
  if (!stores) return <ListUnavailable testID="stores-unavailable" />;
  if (stores.length === 0) {
    return (
      <ListEmpty
        testID="stores-empty"
        text={I18n.t('customerSettings.noStores', {
          defaultValue: 'No stores connected'
        })}
      />
    );
  }
  return (
    <View testID="stores-list">
      {stores.map(store => (
        <View
          key={store.id}
          style={[styles.settingRow, styles.settingRowMain]}
          testID={`store-${store.id}`}
        >
          <Text style={styles.settingLabel}>{store.name}</Text>
          <Text style={styles.settingSavingText}>{store.store_type}</Text>
          {store.status === false ? (
            <View style={styles.groupBadge}>
              <Text
                style={styles.groupBadgeText}
                testID={`store-${store.id}-inactive`}
              >
                {I18n.t('customerSettings.storeInactive')}
              </Text>
            </View>
          ) : null}
        </View>
      ))}
    </View>
  );
};

export default StoresList;
